<nz-divider [nzText]="text" nzOrientation="left" style="margin: 0 0 15px 0">
  <ng-template #text>
    {{ 'calendar.services' | translate }}
    <button nz-button (click)="addEditService()">
      <i nz-icon nzType="plus"></i>
    </button>
  </ng-template>
</nz-divider>

<div nz-row [nzGutter]="[8, 8]" class="overflow-row">
  @for (item of apartmentFacade.services$ | async; track item; let i = $index) {
    <div
      nz-col
      [nzSpan]="24"
      >
      <nz-card>
        <div nz-row nzJustify="space-between">
          <div nz-col>
            {{ item.service.name }}
          </div>
          <div nz-col>
            <i
              nz-icon
              nzType="field-time"
              nzTheme="outline"
              style="color: #1890ff"
            ></i>
            {{ item.time }}
            @if (item.salePrice) {
              <nz-divider nzType="vertical"></nz-divider>
              <i
                nz-icon
                nzType="money-collect"
                nzTheme="outline"
                style="color: #1890ff"
              ></i>
              {{ item.salePrice }} ლარი
              <del>{{ item.price }} ლარი</del>
            }
            @if (!item.salePrice) {
              <nz-divider nzType="vertical"></nz-divider>
              <i
                nz-icon
                nzType="money-collect"
                nzTheme="outline"
                style="color: #1890ff"
              ></i>
              {{ item.price }} ლარი
            }
            @if (item.products && item.products.length) {
              <nz-divider nzType="vertical"></nz-divider>
              <i
                nz-icon
                nzType="shopping-cart"
                nzTheme="outline"
                style="color: #1890ff"
              ></i>
              {{ item.products.length }}
            }
            <!-- micro-39: the line salary is not masked by the API (json column), so gate it here. -->
            <ng-container *ngxPermissionsOnly="['field.employee_salary']">
              @if (item.salaryPercent) {
                <nz-divider nzType="vertical"></nz-divider>
                <nz-tag nzColor="default">{{ item.salaryPercent }}%</nz-tag>
              }
            </ng-container>
          </div>
        </div>
        <div nz-row nzJustify="space-between" nzAlign="bottom" style="margin-top: 10px">
          <div nz-col nzFlex="90%">
            @for (specService of item.specServices; track specService) {
              <nz-tag
                [nzColor]="'blue'"
                style="margin-top: 2px"
                >
                {{ specService?.service?.name }}
              </nz-tag>
            }
          </div>
          <div nz-col nzFlex="5%">
            <nz-space [nzSize]="16" >
              <i
                *nzSpaceItem
                nz-icon
                nzType="edit"
                nzTheme="outline"
                style="cursor: pointer"
                (click)="addEditService(item, i)"
              ></i>
              @if (apartmentFacade.status !== 2) {
                <i
                  *nzSpaceItem
                  nz-popconfirm
                  nzPopconfirmTitle="ნამდვილად გსურთ წაშლა?"
                  nzPopconfirmPlacement="bottom"
                  (nzOnConfirm)="delete(item, i)"
                  nz-icon
                  nzType="delete"
                  nzTheme="outline"
                  style="cursor: pointer"
                ></i>
              }
            </nz-space>
          </div>
        </div>
        <ng-container *ngxPermissionsOnly="['field.employee_salary']">
          @if (!item.salaryPercent && !item.salaryFixed ) {
            <nz-alert nzType="warning" nzMessage="პროცედურაში არ არის მითითებული ხელფასის პროცენტი ან ფიქსირებული" nzShowIcon></nz-alert>
          }
        </ng-container>
      </nz-card>
    </div>
  }
</div>
